export default "__VITE_ASSET__a89cba9e__"